"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setConnectEagerlyItem = exports.getConnectEagerlyItem = exports.setItem = exports.getItem = void 0;
const storages = {
    connectEagerly: 'aelf-connect-eagerly',
};
function getItem(key) {
    return localStorage.getItem(key);
}
exports.getItem = getItem;
function setItem(key, value) {
    return localStorage.setItem(key, value);
}
exports.setItem = setItem;
function getConnectEagerlyItem() {
    return JSON.parse(getItem(storages.connectEagerly));
}
exports.getConnectEagerlyItem = getConnectEagerlyItem;
function setConnectEagerlyItem(value) {
    return setItem(storages.connectEagerly, JSON.stringify(value));
}
exports.setConnectEagerlyItem = setConnectEagerlyItem;
